import { Card, CardContent, Typography, makeStyles } from "@material-ui/core";

import dayjs from "dayjs";
import { fetchApplicationHistoryExternalUser } from "../../../services/applicationsHistory";
import useLocale from "../../../hooks/useLocale";
import { useQuery } from "react-query";

const useStyles = makeStyles({
  root: {
    "& .MuiTextField-root": {
      margin: 15,
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 1)", // (default alpha is 0.38)
    },
  },
  card: {
    minWidth: 275,
    marginTop: 15,
    marginBottom: 15,
    alignSelf: "center",
  },
  viewDetails: {
    width: 700,
    height: 400,
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column-reverse",
  },
  historyCard: {
    // marginTop: 15,
    margin: "15px 15px 15px 15px",
    minWidth: "500px",
    // marginBottom: 15,
  },
  cardTitle: {
    margin: "10px 15px",
  },
  cardContent: {
    // display: "flex",
    // flexWrap: "wrap",
  },
  statusContainer: {
    display: "flex",
  },
  cardItem: {
    margin: "15px",
  },
});

const SeeHistory = ({ id }) => {
  const classes = useStyles();
  const { t } = useLocale();
  const {
    data: history,
    isError,
    isLoading,
    refetch,
  } = useQuery(["applicationHistoryWithIdExternalUser", id], () =>
    fetchApplicationHistoryExternalUser(id)
  );
  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContainer}>
        {history?.map((hist, index) => (
          <Card
            key={hist.id}
            className={classes.historyCard}
            variant="outlined"
          >
            <Typography variant="h4" gutterBottom className={classes.cardTitle}>
              {index + 1}. {dayjs(hist.change_dt).format("DD/MM/YYYY HH:mm:ss")}
            </Typography>
            <CardContent className={classes.cardContent}>
              <div className={classes.statusContainer}>
                <div className={classes.cardItem}>
                  <Typography variant="subtitle2" color="textSecondary">
                    {t("Old status")}
                  </Typography>
                  <Typography variant="h6" gutterBottom>
                    {hist.oldStatus || t("New application")}
                  </Typography>
                </div>
                <div className={classes.cardItem}>
                  <Typography variant="subtitle2" color="textSecondary">
                    {t("New status")}
                  </Typography>
                  <Typography variant="h6" gutterBottom>
                    {hist.newStatus}
                  </Typography>
                </div>
              </div>
              <div className={classes.cardItem}>
                <Typography variant="subtitle2" color="textSecondary">
                  {t("Comment")}
                </Typography>
                <Typography variant="h6" gutterBottom>
                  {hist.comments || "-"}
                </Typography>
              </div>
            </CardContent>
          </Card>
        ))}
      </CardContent>
    </Card>
  );
};

export default SeeHistory;
